<template>
    <v-list>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!isSecuritySupervisorEmployee"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/historial">
            <v-list-tile-action>
                <v-icon>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Historial')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!isSecuritySupervisorEmployee"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/invitacion_tab">
            <v-list-tile-action>
                <v-icon>event</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Invitacion')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                v-if="isSecuritySupervisorEmployee && getProfile.enable_security === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/dashboard">
            <v-list-tile-action>
                <v-icon>security</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile>{{$t('security_module')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>

        <v-list-group
                v-if="!isSecuritySupervisorEmployee && getProfile.enable_shipments === true && getProfile.shipments_management === true"
                append-icon="arrow_drop_down"
                active-class="white--text"
                prepend-icon="anchor"
        >
            <v-list-tile slot="activator">
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('shipments')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
                    <v-list-tile 
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup4">
                <v-list-tile-action>
                    <v-icon medium>anchor</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('informative_shipments')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup">
                <v-list-tile-action>
                    <v-icon medium>event</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Invitacion')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/clients">
                <v-list-tile-action>
                    <v-icon medium>corporate_fare</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Plantas Destino</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/landing_areas">
                <v-list-tile-action>
                    <v-icon medium>forklift</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('landing_area')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/types_of_transport">
                <v-list-tile-action>
                    <v-icon medium>unarchive</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('types_of_transport')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!isSecuritySupervisorEmployee"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/invitados_no_confirmados">
            <v-list-tile-action>
                <v-icon>person_add_disabled</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('invitados_no_confirmados')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <!--<v-list-tile-->
                <!--class="tile"-->
                <!--active-class="blue-grey darken-1 white&#45;&#45;text"-->
                <!--router to="/grupos">-->
            <!--<v-list-tile-action>-->
                <!--<v-icon>supervisor_account</v-icon>-->
            <!--</v-list-tile-action>-->
            <!--<v-list-tile-content>-->
                <!--<v-list-tile >{{$t('grupos')}}</v-list-tile>-->
            <!--</v-list-tile-content>-->
        <!--</v-list-tile>-->
        <v-list-tile
            v-if="!isSecuritySupervisorEmployee"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/firma_salida">
            <v-list-tile-action>
                <v-icon>check_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('firma_salida')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
            v-if="!isSecuritySupervisorEmployee && getProfile.is_supervisor === true && getProfile.enable_shipments === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup3">
            <v-list-tile-action>
                <v-icon>anchor</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('supervise_shipments')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
                    <v-list-tile
                     v-if="!isSecuritySupervisorEmployee && getProfile.is_supervisor === true && getProfile.enable_shipments === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/access_shipments_records">
                <v-list-tile-action>
                    <v-icon >calendar_today</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                        <v-list-tile >{{$t('Historial')}}</v-list-tile>
                </v-list-tile-content>
            </v-list-tile>
        <!-- <v-list-tile v-if="getProfile.is_supervisor === true && getProfile.enable_shipments === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup4">
                <v-list-tile-action>
                    <v-icon medium>anchor</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        {{$t('informative_shipments')}}
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile> -->
        <v-divider></v-divider>
        <v-list-group
            v-if="!isSecuritySupervisorEmployee && (getProfile.supplier_management === true || getProfile.is_rrhh === true)"
                append-icon="arrow_drop_down"
                active-class="white--text"
                prepend-icon="menu_book"
        >
            <v-list-tile slot="activator">
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('catalogos')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                v-if="getProfile.is_rrhh === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/empleados">
                <v-list-tile-action>
                    <v-icon medium>person</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Empleados')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <!-- <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/vigilantes">
                <v-list-tile-action>
                    <v-icon medium>assignment_ind</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Vigilantes')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile> -->
            <v-list-tile
                v-if="getProfile.supplier_management === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/proveedores">
                <v-list-tile-action>
                    <v-icon medium>airport_shuttle</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('proveedores')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <!-- <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/files_company">
                <v-list-tile-action>
                    <v-icon medium>attach_file</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('files')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                v-if="getProfile.enable_contractors === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/admin_workers">
                <v-list-tile-action>
                    <v-icon medium>engineering</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('workers')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/areas">
                <v-list-tile-action>
                    <v-icon medium>store</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Areas')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/casetas">
                <v-list-tile-action>
                    <v-icon medium>local_convenience_store</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Casetas')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile> -->
        </v-list-group>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!isSecuritySupervisorEmployee"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/configuracion">
            <v-list-tile-action>
                <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('configuracion')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
            v-if="!isSecuritySupervisorEmployee"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/ayuda_admin">
            <v-list-tile-action>
                <v-icon>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Ayuda')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex'
    
    export default {
        name: "admin",
        computed: {
                    ...mapGetters(['getProfile']),
                    isSecuritySupervisorEmployee() {
                        return this.getProfile.roll === 1 && this.getProfile.security_supervisor === true
                    }
        },
        name: "empleado",
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
    .tile {
        margin: 5px;
        border-radius: 4px;
    }
</style>
